import { useState, useEffect } from 'react';
import apiService from '../services/api';

const cache = {};
const promises = {};

function fetchList(key) {
  if (cache[key]) return Promise.resolve(cache[key]);
  if (promises[key]) return promises[key];
  promises[key] = apiService.getShippingConfig(key)
    .then(v => { cache[key] = v; return v; })
    .catch(() => { cache[key] = []; return []; })
    .finally(() => { promises[key] = null; });
  return promises[key];
}

export function preloadShippingConfig() { fetchList('country'); fetchList('city'); }

export function formatCitiesForDisplay(list) {
  if (!list || list.length === 0) return null;
  return list
    .map((c) => c.charAt(0).toUpperCase() + c.slice(1))
    .join(', ');
}

export function formatCountriesForDisplay(list) {
  if (!list || list.length === 0) return null;
  return list
    .map((c) => c.charAt(0).toUpperCase() + c.slice(1))
    .join(', ');
}

export default function useShippingConfig() {
  const [cities, setCities] = useState(cache.city || []);
  const [countries, setCountries] = useState(cache.country || []);

  useEffect(() => {
    fetchList('city').then(setCities);
    fetchList('country').then(setCountries);
  }, []);

  return { cities, countries, formatCitiesForDisplay, formatCountriesForDisplay };
}
